// import PropTypes from "prop-types";
import BasicReactTableWrapper from "../../../shared_components/basic_react_table_wrapper";

class GlobalHistogramTable extends BasicReactTableWrapper {
  labelColumnIndex(i) {
    return i < 2;
  }

  decimals() {
    return 0;
  }
}

GlobalHistogramTable.propTypes = Object.assign({}, BasicReactTableWrapper.propTypes, {
});


export default GlobalHistogramTable;
